import React from "react";
import { useSelector } from "react-redux";

const LicenseInfo = () => {
  const licenseInfo = useSelector((state) => state.systemAdmin.licenseInfo);
  const expiryDate =
    licenseInfo?.expiryDate !== 0 ? licenseInfo?.expiryDate : "Never";
  return (
    <div className="license__content__info" data-testid="license-info-content">
      <span className="license__content__info__title">License Information</span>
      <div>
        <span>Total License Count</span>
        <span>{licenseInfo?.licenseCount}</span>
      </div>
      <div>
        <span>Total Licensed Users</span>
        <span>{licenseInfo?.licensedUsers}</span>
      </div>
      <div>
        <span>Available Licenses</span>
        <span>{licenseInfo?.unusedLicenses}</span>
      </div>
      <div>
        <span>Available Reserved Licenses</span>
        <span>{licenseInfo?.unusedReservedLicenses}</span>
      </div>
      <div>
        <span>Licensed Users in Multiple Workspaces</span>
        <span>{licenseInfo?.multiWorkspaceUsers}</span>
      </div>
      <div>
        <span>Expiry Date</span>
        <span>{expiryDate}</span>
      </div>
    </div>
  );
};

export default LicenseInfo;
